import React from 'react';
import { Link } from 'react-router-dom';

const AdminSidebar = () => {
  const pathname = window.location.pathname;
  const pathArray = pathname.split('/').filter(Boolean);

  return (
    <>
      <div className="sidebar -dashboard" id="vendorSidebarMenu">
        <div className="sidebar__item ">
          <Link
            to="/"
            className={`${
              pathArray.length === 0 && '-is-active'
            } sidebar__button d-flex items-center text-15 lh-1 fw-500`}>
            <img
              width={20}
              height={20}
              src="/img/dashboard/sidebar/compass.svg"
              alt="icon"
              className="mr-15"
            />
            Dashboard
          </Link>
        </div>
        {/* End accordion__item */}

        <div className="sidebar__item ">
          <Link
            to="/bookings"
            className={`${
              pathArray[0] === 'bookings' && '-is-active'
            } sidebar__button d-flex items-center text-15 lh-1 fw-500`}>
            <img
              width={20}
              height={20}
              src="/img/dashboard/sidebar/booking.svg"
              alt="icon"
              className="mr-15"
            />
            Pesanan
          </Link>
        </div>

        <div className="sidebar__item ">
          <Link
            to="/review"
            className={`${
              pathArray[0] === 'review' && '-is-active'
            } sidebar__button d-flex items-center text-15 lh-1 fw-500`}>
            <img
              width={20}
              height={20}
              src="/img/dashboard/sidebar/booking.svg"
              alt="icon"
              className="mr-15"
            />
            Review
          </Link>
        </div>
        {/* End accordion__item */}

        {/* <div className="sidebar__item ">
          <Link
            to="/users"
            className={`${
              pathArray[0] === 'users' && '-is-active'
            } sidebar__button d-flex items-center text-15 lh-1 fw-500`}>
            <img
              width={20}
              height={20}
              src="/img/dashboard/sidebar/booking.svg"
              alt="icon"
              className="mr-15"
            />
            Pengguna
          </Link>
        </div> */}
        {/* End accordion__item */}

        {/* <div className="sidebar__item ">
          <Link
            to="/promotions"
            className={`${
              pathArray[0] === 'promotions' && '-is-active'
            } sidebar__button d-flex items-center text-15 lh-1 fw-500`}>
            <img
              width={20}
              height={20}
              src="/img/dashboard/sidebar/booking.svg"
              alt="icon"
              className="mr-15"
            />
            Program Promosi
          </Link>
        </div> */}

        {/* <div className="sidebar__item ">
          <Link
            to="/closing-schedule"
            className={`${
              pathArray[0] === 'closing-schedule' && '-is-active'
            } sidebar__button d-flex items-center text-15 lh-1 fw-500`}>
            <img
              width={20}
              height={20}
              src="/img/dashboard/sidebar/booking.svg"
              alt="icon"
              className="mr-15"
            />
            Jadwal Tutup
          </Link>
        </div> */}

        {/* <div className="sidebar__item ">
          <Link
            to="/withdrawl"
            className={`${
              pathArray[0] === 'withdrawl' && '-is-active'
            } sidebar__button d-flex items-center text-15 lh-1 fw-500`}>
            <img
              width={20}
              height={20}
              src="/img/dashboard/sidebar/booking.svg"
              alt="icon"
              className="mr-15"
            />
            Penarikan Saldo
          </Link>
        </div> */}

        {/* <div className="sidebar__item ">
          <Link
            to="/bank-account"
            className={`${
              pathArray[0] === 'bank-account' && '-is-active'
            } sidebar__button d-flex items-center text-15 lh-1 fw-500`}>
            <img
              width={20}
              height={20}
              src="/img/dashboard/sidebar/gear.svg"
              alt="icon"
              className="mr-15"
            />
            Rekening Bank
          </Link>
        </div> */}

        {/* <div className="sidebar__item ">
          <Link
            to="/profile"
            className={`${
              pathArray[0] === 'profile' && '-is-active'
            } sidebar__button d-flex items-center text-15 lh-1 fw-500`}>
            <img
              width={20}
              height={20}
              src="/img/dashboard/sidebar/gear.svg"
              alt="icon"
              className="mr-15"
            />
            Profil
          </Link>
        </div> */}

        {/* <div className="sidebar__item ">
          <Link
            to="/packages"
            className={`${
              pathArray[0] === 'packages' && '-is-active'
            } sidebar__button d-flex items-center text-15 lh-1 fw-500`}>
            <img
              width={20}
              height={20}
              src="/img/dashboard/sidebar/bookmark.svg"
              alt="icon"
              className="mr-15"
            />
            Paket Wisata
          </Link>
        </div> */}
        {/* End accordion__item */}

        {/* <div className="sidebar__item ">
          <Link
            to="/tenant-costs"
            className={`${
              pathArray[0] === 'tenant-costs' && '-is-active'
            } sidebar__button d-flex items-center text-15 lh-1 fw-500`}>
            <img
              width={20}
              height={20}
              src="/img/dashboard/sidebar/gear.svg"
              alt="icon"
              className="mr-15"
            />
            Master Biaya
          </Link>
        </div> */}
        {/* End accordion__item */}

        {/* <div className="sidebar__item ">
          <Link
            to="/income"
            className={`${
              pathArray[0] === 'income' && '-is-active'
            } sidebar__button d-flex items-center text-15 lh-1 fw-500`}>
            <img
              width={20}
              height={20}
              src="/img/dashboard/sidebar/booking.svg"
              alt="icon"
              className="mr-15"
            />
            Laporan Pemasukan
          </Link>
        </div> */}

        {/* <div className="sidebar__item ">
          <Link
            to="/expense"
            className={`${
              pathArray[0] === 'expense' && '-is-active'
            } sidebar__button d-flex items-center text-15 lh-1 fw-500`}>
            <img
              width={20}
              height={20}
              src="/img/dashboard/sidebar/booking.svg"
              alt="icon"
              className="mr-15"
            />
            Laporan Pengeluaran
          </Link>
        </div> */}

        {/* <div className="sidebar__item ">
          <Link
            to="/cashflow"
            className={`${
              pathArray[0] === 'cashflow' && '-is-active'
            } sidebar__button d-flex items-center text-15 lh-1 fw-500`}>
            <img
              width={20}
              height={20}
              src="/img/dashboard/sidebar/booking.svg"
              alt="icon"
              className="mr-15"
            />
            Laporan Arus Kas
          </Link>
        </div> */}
        {/* End accordion__item */}
      </div>
    </>
  );
};

export default AdminSidebar;
